<template>
  <ui-box class="ui-box-apply" bgType="light">
    <template v-slot:nav-left>
      <ui-tag class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">队员信息</span>
          <span class="label-text">队员信息</span>
        </div>
      </ui-tag>
    </template>
    <template v-slot:nav-right>
      <div class="right-box">
        <button class="btn-exit" @click="handleExit"></button>
      </div>
    </template>
    <template v-slot:container>
      <div class="inner-container">
        <div class="scroll-box">
          <div class="info-box">
            <div v-for="(item, i) in player" :key="i">
              <div class="row">
                <input
                  type="text"
                  v-model="item.nick"
                  :placeholder="`${item.label} - 昵称(填正式服ID显示)`"
                  disabled
                />
                <input
                  v-if="item.position == 'leader'"
                  type="text"
                  v-model="item.contact"
                  :placeholder="`${item.label} - 联系方式,需标明QQ微信`"
                >
              </div>
              <div class="row">
                <input
                  type="text"
                  v-model="item.uid"
                  :placeholder="`${item.label} - 正式服ID`"
                  :disabled="item.position == 'leader'"
                  :class="{ err: !item.valid }"
                  @blur="reqNick(item)"
                />
                <input
                  type="text"
                  v-model="item.address"
                  :placeholder="`${item.label} - 现居地(精确到市)`"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="bg"></div>
          <div class="decorate"></div>
          <ui-frame-bg class="btn" colorType="yellow" @click.native="next">
            <div class="label-box">
              <span class="label-shadow">下一项</span>
              <span class="label-text">下一项</span>
            </div>
          </ui-frame-bg>
        </div>
      </div>
    </template>
  </ui-box>
</template>

<script>
import { mapState } from "vuex";
import UiBox from '@/components/ui-box';
import UiTag from '@/components/ui-tag';
import UiFrameBg from '@/components/ui-frame-bg';
import * as api from '@/service/index';

export default {
  components: { UiBox, UiTag, UiFrameBg },
  inject: ['apply_info', 'handleStepSubmit', 'handleStep', 'promptMsg'],
  data() {
    return {
      player: [
        {
          position: 'leader',
          label: '队长',
          uid: '',
          nick: '',
          valid: true,
          address: '',
          contact: ''
        },
        {
          position: 'player',
          label: '队员1',
          uid: '',
          nick: '',
          valid: true,
          address: ''
        },
        {
          position: 'player',
          label: '队员2',
          uid: '',
          nick: '',
          valid: true,
          address: ''
        },
        {
          position: 'player',
          label: '队员3',
          uid: '',
          nick: '',
          valid: true,
          address: ''
        },
        {
          position: 'substitute',
          label: '替补',
          uid: '',
          nick: '',
          valid: true,
          address: ''
        }
      ],
      mapLabel: {
        uid: 'ID',
        nick: 'ID不存在',
        address: '现居地',
        contact: '联系方式'
      },
      loading: false
    }
  },
  computed: {
    ...mapState(['token']),
    Info() {
      return this.apply_info()
    }
  },
  watch: {
    'Info': {
      handler(val, oldVal) {
        if(val != oldVal && val.uid) {
          let leader = this.player.find(item => item.position == 'leader');
          leader.uid = val.uid;
          this.reqNick(leader);
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    validInfo() {
      let valid = true;

      // 验证是否填写信息
      for(let item of this.player) {
        if(
          (item.position != 'substitute' && (!item.uid || !item.address || !item.nick || (item.position == 'leader' && !item.contact))) ||
          (item.position == 'substitute' && (item.uid || item.address || item.nick))
        ) {
          if(item.uid && !item.nick) {
            valid = false;
            this.promptMsg(`${item.label} - ${this.mapLabel['nick']}`);
            break;
          }else if(!item.uid) {
            valid = false;
            this.promptMsg(`请填写: ${item.label} - ${this.mapLabel['uid']}`);
            break;
          }else if(item.position == 'leader' && !item.contact) {
            valid = false;
            this.promptMsg(`请填写: ${item.label} - ${this.mapLabel['contact']}`);
            break;
          }else if(!item.address) {
            valid = false;
            this.promptMsg(`请填写: ${item.label} - ${this.mapLabel['address']}`);
            break;
          }
        }
      }

      // 验证至少包含3名队员
      if(valid) {
        let p = this.player.filter(item => item.position != 'substitute' && item.uid);
        if(p.length != 4) {
          valid = false;
          this.promptMsg('至少包含3名队员');
        }
      }

      // 验证是否重复填写队员
      if(valid) {
        let tempArr = this.player.map(item => item.uid);
        let is_report = this.player.some((item, index) => index != tempArr.indexOf(item.uid));
        if(is_report) {
          valid = false;
          this.promptMsg('队员信息重复');
        }
      }

      return valid;
    },
    next() {
      let valid = this.validInfo();
      if(valid) {
        this.handleStepSubmit(2, this.player);
        this.handleStep(3)
      }
    },
    reqNick(item) {
      if(!item.uid) {
        item.nick = '';
        return;
      }

      let subNick = sessionStorage.getItem(item.uid);
      if(subNick) {
        item.nick = JSON.parse(subNick);
        item.valid = true;
      }else {
        // 当找不到缓存时, 请求验证
        if(this.loading) return;
        if(!this.token) return;
        this.loading = true;
        api.reqNick({
          token: this.token,
          uid: item.uid
        }).then(r => {
          if(r.status == 200) {
            item.nick = this.$lg(r.data, 'nick', '');
            if(item.nick) {
              item.valid = true

              // 为了减少非必要uid验证, 采用sessionstorage缓存
              sessionStorage.setItem(item.uid, JSON.stringify(item.nick));
            }else {
              this.promptMsg('未找到该用户信息')
              item.valid = false
            }
          }else {
            this.promptMsg(r.data)
            item.nick = ''
            item.valid = false
          }
          this.loading = false;
        })
      }
    },
    handleExit() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  i {
    position: relative;
    @include sizeSet($width: 36px, $height: 36px);
    @include icon_status('team_2', $hook: 'all');
    margin-right: get_vh(8px);
  }
  .label-box {
    .label-shadow {
      color: #FFFFFF;
    }
    .label-text {
      color: #133469;
    }
  }
}

.right-box {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  height: 100%;
  .btn-exit {
    @include sizeSet($width: 92px, $height: 44px);
    background-image: $bg_btn;
    background-size: get_vh(786px) get_vh(384px);
    background-position: get_vh(-13px) get_vh(-212px);
    background-repeat: no-repeat;
    @include marginSet($marginTop: 4px);
    @include boxShadowSet_Btn;
    @media screen and (max-aspect-ratio: 3/2) {
      background-size: get_vw(786px) get_vw(384px);
      background-position: get_vw(-13px) get_vw(-212px);
    }
  }
}

.inner-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px get_vh(20px) get_vh(20px);
  overflow: hidden;
  .scroll-box {
    flex: 1;
    width: 98.5%;
    margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: get_vh(33px);
    padding-bottom: get_vh(50px);
    .info-box {
      width: get_vw(824px);
      margin: 0 auto;
      .row {
        width: 100%;
        height: get_vw(68px);
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin-bottom: get_vh(30px);
        input {
          width: get_vw(362px);
          height: 100%;
          border: get_vh(2px) solid #ccc;
          background-color: #fff;
          border-radius: get_vh(10px);
          font-size: get_vh(20px);
          color: #333;
          padding-left: get_vw(35px);
          outline: none;
          &:disabled {
            background-color: #eee;
          }
          // &.no-border {
          //   border: 2px solid #fafafa;
          // }

          @media screen and (max-aspect-ratio: 3 / 2) {
            font-size: get_vh(18px);
          }
        }
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: #cccccc;
          opacity: 1; /* Firefox */
        }
        :-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: #cccccc;
        }
        ::-ms-input-placeholder { /* Microsoft Edge */
          color: #cccccc;
        }

        @keyframes shake {
          0% {
            transform: translate3d(0, 0, 0);
          }
          25% {
            transform: translate3d(-0.5vw, 0, 0);
          }
          75% {
            transform: translate3d(0.5vw, 0, 0);
          }
          100% {
            transform: translate3d(0, 0, 0);
          }
        }
        .err {
          border: get_vh(2px) solid #EA3323;
          animation: shake 150ms ease-in-out;
        }
      }
    }
  }
  .bottom-box {
    position: relative;
    width: 100%;
    height: get_vh(124px);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .decorate {
      position: absolute;
      bottom: get_vh(-80px);
      right: get_vh(360px);;
      width: get_vh(164px);
      height: get_vh(167px);
      background-image: $bg_decorate;
      background-size: get_vh(1472px) get_vh(639px);
      background-position: get_vh(-574px) get_vh(-104px);
      background-repeat: no-repeat;
    }
    .bg {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: get_vh(180px);
      background-image: $bg_bottom;
      background-size: 100% 100%;
      background-position: center top;
      background-repeat: no-repeat;
    }
    .btn {
      position: relative;
      width: get_vh(266px);
      height: get_vh(70px);
      font-size: get_vh(28px);
      font-weight: bold;
      @include boxShadowSet_Btn;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      margin-right: get_vh(42px);
      &:active {
        opacity: 0.9;
      }
    }
  }
}
</style>